const API_URL = "https://your-backend-api.com"; // Replace with actual API URL

export const getCurrentUser = async () => {
  /*try {
    const response = await fetch(`${API_URL}/auth/current-user`, {
      credentials: "include", // If using sessions/cookies
    });
    if (!response.ok) throw new Error("Not authenticated");
    return response.json();
  } catch (error) {
    console.error("Error fetching user:", error);
    return null;
  }*/
  return {};
};


export const getUserProfile = async () => {
 /* try {
    const response = await fetch(`${API_URL}/users/profile`, { credentials: "include" });
    return response.json();
  } catch (error) {
    console.error("Error fetching user profile:", error);
    return null;
  }*/
  return {};

};

export const getUserTeams = async () => {
  /*try {
    const response = await fetch(`${API_URL}/teams`, { credentials: "include" });
    return response.json();
  } catch (error) {
    console.error("Error fetching user teams:", error);
    return [];
  }*/

  return [];

};

export const getLinkedAccounts = async () => {
  /*try {
    const response = await fetch(`${API_URL}/users/linked-accounts`, { credentials: "include" });
    return response.json();
  } catch (error) {
    console.error("Error fetching linked accounts:", error);
    return [];
  }*/
  return [];

};


export const getTeamDetails = async (teamId) => {
    /*try {
      const response = await fetch(`https://your-backend-api.com/teams/${teamId}`, {
        credentials: "include",
      });
      return response.json();
    } catch (error) {
      console.error("Error fetching team details:", error);
      return null;
    }*/
   return {}
  };
  
  export const updateTeam = async (teamId, updatedData) => {
    /*try {
      const response = await fetch(`https://your-backend-api.com/teams/${teamId}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify(updatedData),
      });
      return response.json();
    } catch (error) {
      console.error("Error updating team:", error);
      throw error;
    }*/
   return {}
  };
  


export const getUserSettings = async () => {
  /*try {
    const response = await fetch(`${API_URL}/user/settings`, {
      credentials: "include",
    });
    if (!response.ok) throw new Error("Failed to fetch user settings");
    return response.json();
  } catch (error) {
    console.error("Error fetching user settings:", error);
    return null;
  }*/
  return {}
};

export const updateUserSettings = async (data) => {
  /*try {
    const response = await fetch(`${API_URL}/user/settings`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify(data),
    });
    if (!response.ok) throw new Error("Failed to update settings");
    return response.json();
  } catch (error) {
    console.error("Error updating settings:", error);
    throw error;
  }*/

  return{}
};



export const linkAccount = async (email) => {
  /*try {
    const response = await fetch(`${API_URL}/user/link-account`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify({ email }),
    });
    if (!response.ok) throw new Error("Failed to link account");
    return response.json();
  } catch (error) {
    console.error("Error linking account:", error);
    throw error;
  }*/
  return {}
};






export const getUserLinkedAccounts = async (email) => {
  /*try {
    const response = await fetch(`${API_URL}/user/linked-accounts?email=${email}`, {
      credentials: "include",
    });
    if (!response.ok) throw new Error("Failed to fetch linked accounts");
    return response.json();
  } catch (error) {
    console.error("Error fetching linked accounts:", error);
    return { linkedEmails: [] };
  }*/
  return {}
};

export const linkCurrentAccount = async (newEmail) => {
  /*try {
    const response = await fetch(`${API_URL}/user/link-account`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify({ email: newEmail }),
    });
    if (!response.ok) throw new Error("Failed to link account");
    return response.json();
  } catch (error) {
    console.error("Error linking account:", error);
    throw error;
  }*/

  return{}
};
